import React, {memo, useContext, useEffect, useState} from 'react';
import MergeGridItem from '../../../../shared/components/mergeBoard/MergeGridItem';
import {PlayerContext} from "../../../../shared/contexts/playerContext";
import {useMergeEventBlockMainData, useMergeEventData} from "../../../logs/useTableData";
import IsLoading from "../../../../shared/components/IsLoading";
import ErrorPage from "../../../../shared/components/ErrorPage";
import {Button, Tooltip} from 'antd';
import CollectionModal from './CollectionModal';
import MergeInventoryList from "../../../../shared/components/mergeBoard/MergeInventoryList";
import {MERGE_EVENT_TYPE} from "../../../../shared/utils/enum";

const MergeEventGrid = memo(() => {
    const {playerData, setPlayerData} = useContext(PlayerContext);
    const blocks = playerData?.playerInfo?.mergeEventData?.ActiveMergeEventState?.boardData?.slotData || [];
    const [isCollectionModalOpen, setIsCollectionModalOpen] = useState(false);
    const collection = playerData?.playerInfo?.mergeEventData?.ActiveMergeEventState?.collectionData || [];
    const [length, setLength] = useState(6);
    const [isRaid, setIsRaid] = useState(false);

    const {
        data: mergeEventMainData,
        isLoading: isMergeEventMainData,
        error: mergeEventMainDataError
    } = useMergeEventBlockMainData();
    const {data: mergeEventData, isLoading: isMergeEventDataLoading, error: mergeEventDataError} = useMergeEventData();

    useEffect(() => {
        setLength(playerData.playerInfo.mergeEventData.ActiveMergeEventState.boardData.slotData[0].length);
        setIsRaid(mergeEventData?.master[playerData?.playerInfo?.mergeEventData?.ActiveMergeEventState?.id]?.mergeEventType === MERGE_EVENT_TYPE.BOSS_RAID || false);
        // blocks.reverse();
    }, [playerData.playerInfo.mergeEventData.ActiveMergeEventState.boardData]);

    const isLoading = isMergeEventMainData || isMergeEventDataLoading;
    const error = mergeEventMainDataError || mergeEventDataError;

    if (isLoading) return <IsLoading/>;
    if (error) return <ErrorPage error={error}/>
    if (isRaid) return null;
    return (
        <div>
            <div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%', // 전체 폭을 차지하도록
                    maxWidth: '500px', // 최대 너비 제한 유지
                    margin: '0 auto', // 중앙 정렬
                    position: 'relative', // 자식 absolute 요소들을 위해
                }}>
                    <div>
                        <Tooltip title="컬렉션">
                            <Button
                                type="text"
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    width: 80,
                                    height: 80,
                                }}
                                onClick={() => setIsCollectionModalOpen(true)}
                            >
                                <img
                                    src="/UI/Images/Event/FinalBlockMergeEvent/FinalBlockMergeEvent01/MergeEvent_HalloweenetbBookdd.png"
                                    alt="Collection"
                                    style={{width: 80, height: 80, display: 'block', objectFit: 'contain'}}
                                />
                            </Button>
                        </Tooltip>
                        <MergeInventoryList
                            mergeInventories={playerData?.playerInfo?.mergeEventData?.ActiveMergeEventState?.boardData?.blockDepot}
                            mergeMainData={mergeEventMainData}
                        />
                    </div>
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: `repeat(${length}, 1fr)`,
                            gap: '2px',
                            width: '100%',
                            padding: '5px',
                            backgroundColor: '#cceeff',
                            borderRadius: '16px',
                            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                            boxSizing: 'border-box',
                            minHeight: 420,
                            minWidth: 300,
                            position: 'relative',
                        }}
                    >
                        {blocks.length === 0 ? (
                            <>
                                <div style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    color: '#888',
                                    fontSize: 18,
                                    zIndex: 2,
                                    pointerEvents: 'none',
                                }}>
                                    데이터가 없습니다.
                                </div>
                                {Array.from({length: 48}).map((_, idx) => (
                                    <div
                                        key={idx}
                                        style={{
                                            width: '100%',
                                            aspectRatio: '1 / 1',
                                            background: '#f5f5f5',
                                            border: '1px solid #e0e0e0',
                                            borderRadius: 6,
                                        }}
                                    />
                                ))}
                            </>
                        ) : (
                            blocks.flat().map((item, index) => (
                                <MergeGridItem
                                    key={item?.eventBlock?.slotIndex ?? `empty-${index}`}
                                    item={item}
                                    mergeMainData={mergeEventMainData}
                                    playerData={playerData}
                                    setPlayerData={setPlayerData}
                                />
                            ))
                        )}
                    </div>
                </div>
                <CollectionModal
                    open={isCollectionModalOpen}
                    onClose={() => setIsCollectionModalOpen(false)}
                    collection={collection}
                    mergeEventMainData={mergeEventMainData}
                />
            </div>
        </div>
    );
});

export default MergeEventGrid;